<template>
  <el-dialog @close="cancel" :title="content.title" :visible.sync="content.show" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" class="panel-container-dialog">
    <el-row :gutter="20" class="gene-page-container">
      <!-- 基因列表主区域：全尺寸占满 -->
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="gene-card">
          <!-- 标题+搜索框区域 -->
          <el-row :gutter="16" class="gene-header" align="middle">
            <el-col :xs="12" :sm="14" :md="16" :lg="18" :xl="18">
              <!-- <h2 class="gene-title">{{ content.title || 'Gene List' }}</h2> -->
              <h2 class="gene-title">Total: {{ filteredGenes.length }}</h2>
            </el-col>
            <el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="6">
              <!-- Element UI 搜索框 -->
              <el-input v-model="searchKeyword" placeholder="Search gene..." prefix-icon="el-icon-search" clearable class="gene-search-input" @input="handleSearch" />
            </el-col>
          </el-row>

          <!-- 数量统计 -->
          <!-- <div class="gene-count"> -->
          <!-- {{ filteredGenes.length }}  -->
          <!-- Genes (Total: {{ geneArray.length }}) -->
          <!-- </div> -->

          <!-- 基因标签列表：流式布局（核心优化） -->
          <div class="gene-tags-wrapper">
            <!-- 无匹配结果提示 -->
            <div class="empty-tip" v-if="filteredGenes.length === 0 && searchKeyword">
              <i class="el-icon-warning empty-icon"></i>
              No genes match "{{ searchKeyword }}"
            </div>

            <!-- 基因标签：自适应宽度，不换行 -->
            <div class="gene-tag" v-for="(gene, index) in filteredGenes" :key="index" @click="handleGeneClick(gene)" v-html="highlightKeyword(gene)"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'GeneList',
  data() {
    return {
      content: {
        show: true,
        list: 'AAAS, AARS1, AARS2, AASS, ABCA1, ABCA2, ABCA7, ABCB7, ABCC8, ABCD1, ABCD3, ABHD12, ABHD5, ACAD9, ACADM, ACADS, ABCDEF123456789',
        title: "Gene List"
      },
      geneArray: [], // 原始基因数组
      filteredGenes: [], // 筛选后的基因数组
      searchKeyword: '' // 搜索关键词
    };
  },
  mounted() {
    // 页面加载后初始化数据并触发筛选
    this.formatGeneList(this.content.list);
    this.handleSearch();
  },
  methods: {
    cancel() { },
    // 格式化原始字符串为基因数组
    formatGeneList(str) {
      if (!str) {
        this.geneArray = [];
        this.filteredGenes = [];
        return;
      }
      // 拆分+去空格+去空值
      this.geneArray = str.split(',').map(function (item) {
        return item.trim();
      }).filter(function (item) {
        return item;
      });
    },

    // 处理搜索逻辑：实时筛选（核心修复）
    handleSearch() {
      var keyword = this.searchKeyword.trim().toLowerCase();
      // 清空搜索，恢复全量
      if (!keyword) {
        this.filteredGenes = [].concat(this.geneArray);
        return;
      }
      // 模糊匹配（不区分大小写）：包含关键词即显示
      this.filteredGenes = this.geneArray.filter(function (gene) {
        return gene.toLowerCase().includes(keyword);
      });
    },

    // 高亮匹配的关键词
    highlightKeyword(gene) {
      var keyword = this.searchKeyword.trim();
      if (!keyword) {
        return gene; // 无关键词，直接返回原文本
      }
      // 构建正则（不区分大小写）
      var reg = new RegExp('(' + keyword + ')', 'gi');
      // 替换匹配部分为高亮标签
      return gene.replace(reg, '<span class="highlight">$1</span>');
    },

    // 点击基因标签：复制到剪贴板
    handleGeneClick(gene) {
      var that = this;
      navigator.clipboard.writeText(gene).then(function () {
        // 兼容写法：先判断 $message 是否存在
        if (that.$message && typeof that.$message.success === 'function') {
          that.$message.success('Copied: ' + gene);
        } else {
          alert('Copied: ' + gene);
        }
      });
    }
  }
};
</script>

<style lang='scss'>
.panel-container-dialog {
  /* 页面整体容器 */
  .gene-page-container {
    padding: 24px;
    max-width: 1400px;
    margin: 0 auto;
    background-color: #f8fafc;
    // min-height: 100vh;
  }

  /* 基因卡片容器：白色背景+轻微阴影 */
  .gene-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 32px 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  /* 标题行 */
  .gene-header {
    margin-bottom: 16px;
  }

  .gene-title {
    margin: 0;
    color: #1e293b;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  /* 搜索框样式优化 */
  .gene-search-input {
    width: 100%;
  }
  .gene-search-input .el-input__inner {
    border-radius: 8px;
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s;
  }
  .gene-search-input .el-input__inner:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  /* 数量统计文本 */
  .gene-count {
    color: #64748b;
    font-size: 14px;
    margin-bottom: 20px;
    padding-left: 4px;
  }

  /* 基因标签容器：流式布局核心 */
  .gene-tags-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px; /* 标签间距（替代margin，更规整） */
    align-items: center;
  }

  /* 基因标签样式：自适应宽度+不换行 */
  .gene-tag {
    /* 核心：宽度自适应内容，不换行 */
    white-space: nowrap; /* 强制不换行 */
    flex-shrink: 0; /* 不被挤压 */
    max-width: 200px; /* 限制最大宽度，避免过长撑破容器 */
    padding: 10px 18px; /* 左右内边距更大，适配长名称 */
    text-align: center;
    background-color: #f1f5f9;
    color: #2563eb;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e2e8f0;
    letter-spacing: 0.3px;
    line-height: 1.4;
    /* ✅ 新增：所有结果斜体 */
    font-style: italic;
  }

  /* 标签悬浮效果 */
  .gene-tag:hover {
    background-color: #2563eb;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(37, 99, 235, 0.15);
  }

  /* 关键词高亮样式 */
  .highlight {
    background-color: #fde68a;
    color: #92400e;
    padding: 0 2px;
    border-radius: 2px;
    font-weight: 600;
  }

  /* 无匹配结果提示 */
  .empty-tip {
    width: 100%;
    text-align: center;
    padding: 48px 0;
    color: #64748b;
    font-size: 16px;
  }
  .empty-icon {
    font-size: 24px;
    margin-bottom: 8px;
    color: #94a3b8;
    display: block;
  }

  /* 响应式适配：小屏幕缩小标签内边距和字体 */
  @media (max-width: 768px) {
    .gene-page-container {
      padding: 16px;
    }
    .gene-card {
      padding: 24px 16px;
    }
    .gene-title {
      font-size: 18px;
    }
    .gene-tag {
      font-size: 13px;
      padding: 8px 14px;
      max-width: 160px;
      /* ✅ 新增：所有结果斜体 */
      font-style: italic;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/panel.vue